// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const loginCenterZh = {
  pageTitle: "{platformName} 平台后台登录",
  eyebrow: "AIRange Control Plane",
  summary: "平台管理类工作台统一通过统一身份接管当前会话，再进入对应控制面。",
  badgePlatform: "平台后台",
  badgeSso: "统一身份",
  badgeLocalFallback: "本地账号",
  badgeMaintenance: "维护模式",
  badgeRunning: "运行中",
  introEntryLabel: "当前入口",
  introEntryValue: "平台层管理后台",
  introEntryHint: "不承载题库、试卷、考试等业务操作，只处理平台级治理能力。",
  introBoundaryLabel: "权限边界",
  introBoundaryValue: "平台管理员可见",
  introBoundaryHint: "与考试业务后台权限隔离，平台角色和业务角色不混用。",
  credentialSection: "登录凭据",
  authSource: "登录方式",
  authSourceSso: "统一身份登录",
  authSourceLocal: "本地登录",
  ssoAlert: "当前将通过统一身份链路登录。平台后台浏览器已直连 sso-center，不再经过业务 API 代理。",
  usernamePlaceholder: "请输入用户名",
  passwordPlaceholder: "请输入密码",
  captchaPlaceholder: "请输入验证码",
  usernameRequired: "请输入用户名",
  passwordRequired: "请输入密码",
  captchaRequired: "请输入验证码",
  submit: "登录平台后台",
  footerPrimary: "统一身份优先",
  footerSecondary: "本地登录用于授权运维场景",
  maintenanceNotice: "当前系统处于维护模式，平台后台仅限授权人员访问。",
  noAccess: "当前账号没有平台后台访问权限。",
  mustChangePassword: "当前账号需要先修改密码，请先前往考试后台完成密码更新。",
  captchaNeeded: "需要输入图形验证码。",
  oidcCallbackProcessing: "正在处理统一身份登录回调...",
  oidcCallbackMissingParams: "统一身份回调缺少 code/state 参数",
  oidcCallbackFailed: "统一身份回调处理失败",
  oidcCallbackRuntimeConfigFailed: "统一身份回调运行时配置读取失败",
  oidcCallbackRetryLogin: "重新登录",
  oidcFailedNotice: "统一身份登录回调失败，请重新发起登录",
} as const;
